import { withStyles } from '@material-ui/core/styles';
import { Table } from '@material-ui/core';

export const BaseTable = withStyles(() => ({
  root: {
    border: 0,
  },
}))(Table);
